export const PROFILE_SAVE_ATTEMPT = 'profile/PROFILE_SAVE_ATTEMPT';

export const PROFILE_SAVE_ATTEMPT_FAILED = 'profile/PROFILE_SAVE_ATTEMPT_FAILE';

export const EMAIL_VERIFICATION_REQUEST_ATTEMPT = 'profile/EMAIL_VERIFICATION_REQUEST_ATTEMPT';

export const EMAIL_VERIFICATION_REQUEST_SEND = 'profile/EMAIL_VERIFICATION_REQUEST_SEND';

export const SET_ACTIVE_TAB = 'profile/SET_ACTIVE_TAB';
